import * as Yup from "yup";

export const taxiCouponSchema = Yup.object().shape({
  name: Yup.string().required("Ce champ est obligatoire"),
  isActive: Yup.boolean().default(true),
  isPublic: Yup.boolean().default(true),
  experationDate: Yup.string().optional(),
  maxUsage: Yup.number()
    .nullable()
    .typeError("")
    .transform((_, val) => (val ? Number(val) : null)),
  maxPerUser: Yup.number()
    .nullable()
    .typeError("")
    .transform((_, val) => (val ? Number(val) : null)),
  comments: Yup.string().optional(),
  discount: Yup.array()
    .of(
      Yup.object().shape({
        registraction: Yup.number()
          .required("Registration is required")
          .min(0, "Must be a positive number"),
        value: Yup.array()
          .of(
            Yup.object().shape({
              usage: Yup.number()
                .typeError("Ce champ est obligatoire")
                .required("Ce champ est obligatoire")
                .min(0, "Must be a positive number"),
              value: Yup.number()
                .typeError("Ce champ est obligatoire")
                .required("Ce champ est obligatoire")
                .min(0, "Must be a positive number"),
            }),
          )
          .min(1, "At least one value is required"),
      }),
    )
    .min(1, "At least one discount is required"),
});
